import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SharedModule } from 'src/app/_shared/_shared.module';
import { SnackBarErrorConfig } from 'src/app/_utils/_material-import/snackbar-config';
import { FiltroPrensaWeb } from 'src/app/home/_models/filtro-prensa-web';
import { NoticiaPrensa } from 'src/app/home/_models/noticia-prensa';
import { PrensaWebService } from 'src/app/home/_services/prensa-web.service';
import Swiper from 'swiper';
import { Autoplay, Pagination } from 'swiper/modules';

@Component({
  selector: 'app-noticias-prensa',
  templateUrl: './noticias-prensa.component.html',
  styleUrls: ['./noticias-prensa.component.scss'],
  standalone: true,
  imports: [
    SharedModule,
    
  ]
})


export class NoticiasPrensaComponent implements OnInit, AfterViewInit
{

  @Input() plataformaId: string;
  isLoading: boolean = false;
  filtroPrensaWeb: FiltroPrensaWeb;
  prensaWeb: NoticiaPrensa[];
  swiperPrensa: Swiper;
  isCNMV: boolean;

  constructor(
    private _matSnackBar: MatSnackBar,
    private _prensaWebService: PrensaWebService) { }

  ngOnInit(): void
  {
    this.getPrensaWeb();
  }

  ngAfterViewInit(): void
  {
    this.buildSwiper();
  }

  private getPrensaWeb(): void
  {
    this.isCNMV = (this.plataformaId === 'REALESTATE' || this.plataformaId === 'VENTURE' || this.plataformaId === 'CREATIVE') ? true : false;
    this.filtroPrensaWeb = {
      isCNMV: this.isCNMV
    }

    this.isLoading = true;
    this._prensaWebService.getPrensaWeb(this.filtroPrensaWeb).subscribe({
      next: (r) =>
      {
        this.isLoading = false;
        this.prensaWeb = r;
      },
      error: (e) =>
      {
        this.isLoading = false;
        this._matSnackBar.open(this._prensaWebService.getServerErrors(e), 'x', new SnackBarErrorConfig());
      }
    });
  }

  private buildSwiper(): void
  {
    Swiper.use([Pagination, Autoplay]);
    this.swiperPrensa = new Swiper('.swiperPrensaWeb', {
      slidesPerView: 1,
      autoplay: { delay: 4000, disableOnInteraction: true },
      // Responsive breakpoints
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 25
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 25
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 25
        },
        1200: {
          slidesPerView: 3,
          spaceBetween: 50
        }
      },
      // Pagination
      pagination: {
        el: '.swiper-pagination.swiper-pagination-prensa',
        clickable: true
      },
    });
  }
}
